import React from "react";
import {useTranslation} from "react-i18next";
import {PhoneNumberDTO} from "../../models/phoneNumber";
import {isoToFlag} from "../../utils/functions";

interface PhoneNumberRowProps {
    phone: PhoneNumberDTO;
    index: number;
    dialOptions: { iso2: string; name: string; dialCode: string }[];
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>, index: number) => void;
    setDialCode: (index: number, dialCodeValue: string) => void;
    removePhoneNumber: (index: number) => void;
    multiple: boolean;
}

export function PhoneNumberRow({
                                   phone,
                                   index,
                                   dialOptions,
                                   onChange,
                                   setDialCode,
                                   removePhoneNumber,
                                   multiple,
                               }: PhoneNumberRowProps) {
    const {t} = useTranslation();

    // Finde das aktuell ausgewählte Land
    const selectedCountry = dialOptions.find(
        (o) => `+${o.dialCode}` === phone.countryCode
    );

    return (
        <div key={index} className={`form-row phoneNumbers ${multiple ? "split-25-65-10" : "split-25-75"}`}>
            <select
                name="countryCode"
                value={phone.countryCode}
                onChange={(e) => setDialCode(index, e.target.value)}
                className="form-input"
            >
                <option value="">{t("contact.fields.phoneDial")}</option>

                {/* Hidden-Option für die eingeklappte Ansicht */}
                {selectedCountry && (
                    <option value={`+${selectedCountry.dialCode}`} hidden>
                        {isoToFlag(selectedCountry.iso2)} +{selectedCountry.dialCode}
                    </option>
                )}

                {/* Alle Länder im Dropdown */}
                {dialOptions.map(({iso2, name, dialCode}) => (
                    <option key={`${iso2}-${dialCode}`} value={`+${dialCode}`}>
                        {isoToFlag(iso2)} {name} (+{dialCode})
                    </option>
                ))}
            </select>

            <input
                type="text"
                name="phoneNumber"
                value={phone.phoneNumber}
                onChange={(e) => {
                    const value = e.target.value;
                    if (/^\s*[1-9][0-9\s]*$/.test(value) || value === "") {
                        onChange(e, index);
                    }
                }}
                className="form-input"
                inputMode="numeric"
                pattern="\s*[1-9][0-9\s]*"
                placeholder={t("contact.fields.phoneNumber")}
            />

            {multiple && (
                <button
                    type="button"
                    onClick={() => removePhoneNumber(index)}
                    className="form-button-secondary"
                >
                    ✖
                </button>
            )}
        </div>
    );
}